import { classSet } from '@platform/ui-library';
import { FC, useState } from 'react';
import { FileUploaderModal, InputAcceptType } from '@app/form_components';
import { useCustomNavigate, useServices } from '@app/hooks';
import { Table } from '@app/page-components';
import { Design } from '@app/types';

export const HomeUploadPage: FC = () => {
  const navigate = useCustomNavigate();
  const {
    avsService,
    loadingService,
    lokiService
  } = useServices();
  const [uploaded, setUploaded] = useState<Design>();

  const childrenAfterUpload = (uploaded) ? (
    <Table
      asTable
      data={[
        ['Client', uploaded.clientName],
        ['Design', uploaded.designName],
        ['Branch', uploaded.branchName],
        ['Version', uploaded.version]
      ].map(([key, value]) => {
        return {
          Key: key,
          Value: value
        };
      })}
    />
  ) : null;
  const childrenBeforeUpload = (uploaded) ? null : (
    <p>Select a Designer JSON file from your computer.</p>
  );

  return (
    <FileUploaderModal
      accept={InputAcceptType.json}
      childrenAfterUpload={childrenAfterUpload}
      childrenBeforeUpload={childrenBeforeUpload}
      className={classSet([uploaded && 'ui-box-small'])}
      isFileNameEditable={false}
      isOpen
      labels={{ header: 'Upload Version' }}
      onParse={(text) => {
        loadingService.useLoading(async () => {
          const serialized = JSON.parse(text);
          await avsService.hydrateImportedDesign(serialized);
          setUploaded(serialized);
        });
      }}
      onComplete={async (file) => {
        if (file && uploaded) {
          if (await lokiService.storeSerialized(uploaded)) {
            navigate('..');
          }
        } else {
          navigate('..');
        }
      }}
      template={null}
    />
  );
};
